import { Edit, Trash2, Send } from "lucide-react";
import { FC } from "react";
import { useLocation } from "wouter";

import { DraftShortResponseDTO } from "@/common/api";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Button,
  TruncateTooltip,
} from "@/common/components";
import { ROUTES } from "@/common/config";

interface DraftCardProps {
  data?: DraftShortResponseDTO;
  onDelete: (id: string) => void;
  onSubmit: (id: string) => void;
}

export const DraftCard: FC<DraftCardProps> = (props) => {
  const { data, onDelete, onSubmit } = props;
  const [, setLocation] = useLocation();

  return (
    <Card key={data?.id} className="hover:shadow-md transition-shadow">
      <CardHeader className="mb-4 md:mb-5">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <CardTitle className="text-lg font-bold uppercase leading-6">
              {data?.orderNumber}
            </CardTitle>
          </div>
          <div className="flex items-center gap-3">
            <Button
              variant="outline"
              size="sm"
              onClick={() => setLocation(ROUTES.EDIT_DRAFT.replace(":id", String(data?.id)))}
            >
              <Edit className="h-4 w-4 mr-1" />
              <span className="hidden md:block">Редактировать</span>
            </Button>
            <Button variant="outline" size="sm" onClick={() => onSubmit(data?.id || "")}>
              <Send className="h-4 w-4 mr-1" />
              <span className="hidden md:block">Отправить</span>
            </Button>
            <Button variant="outline" size="sm" onClick={() => onDelete(data?.id ?? "")}>
              <Trash2 className="h-4 w-4 mr-1" />
              <span className="hidden md:block">Удалить</span>
            </Button>
          </div>
        </div>
      </CardHeader>

      <CardContent>
        <div className="text-sm font-normal text-Text-secondary flex flex-col md:flex-row gap-2">
          <div className="flex gap-2 items-start md:items-center">
            <span className="font-medium leading-5 ">Груз:</span>
            <span className="flex flex-row items-start">
              {data?.cargoId?.cargoName ? (
                <TruncateTooltip text={data?.cargoId?.cargoName ?? "-"} className="" />
              ) : (
                "не указан"
              )}
              {data?.cargoWeight !== 0 && `(${data?.cargoWeight} тонн)`}
            </span>
          </div>

          <div className="hidden md:block w-0 h-4 outline outline-1 outline-offset-[-0.50px] outline-Border-gray" />

          <div className="flex flex-col md:flex-row gap-2 items-start md:items-center">
            <span className="font-medium leading-5 ">Станция отправления (дорога):</span>
            <span className="flex flex-row items-start">
              {data?.loadingStation?.name ? (
                <TruncateTooltip text={data?.loadingStation?.name ?? "-"} className="" />
              ) : (
                "не указано"
              )}

              {data?.loadingStation?.road && `(${data?.loadingStation?.road})`}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
